import { render, staticRenderFns } from "./IdentityFile.vue?vue&type=template&id=6b3b3819&scoped=true&"
import script from "./IdentityFile.vue?vue&type=script&lang=js&"
export * from "./IdentityFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b3819",
  null
  
)

export default component.exports